/**
 * Given a 0-argument function, returns a new function that calls it once,
 * caches the result, and returns the cached result for all future calls.
 */
export function computeOnce<R>(computingFunction: () => R): () => R {
    let box: { value: R } | null = null;
    return () => {
        if (!box) box = { value: computingFunction() };
        return box.value;
    };
}
// TODO: use adhublib
